var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32"
  }, [_c('h3', {
    staticClass: "mb-10 text-pink-600"
  }, [_vm._v("Supprimer le CV")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("Êtes-vous sûr de vouloir supprimer le CV " + _vm._s(_vm.cvToDelete ? '“' + _vm.cvToDelete.name + '“' : '') + " ?")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-5 justify-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-100",
      "bg-color-square": "bg-pink-100",
      "uppercase": true,
      "libelle": "Annuler"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.close(false);
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "uppercase": true,
      "libelle": "Supprimer",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.removeCV(_vm.cvToDelete);
      }
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }